import React from 'react'

export const BehanceIcon = ({
	width = '18',
	height = '14',
	color = '#fff',
	className = '',
}) => (
	<svg
		className={className}
		width={width}
		height={height}
		viewBox="0 0 14 14"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fill={color}
			d="M14.438 2.648h-3.992v.969h3.992v-.969zm-1.969 3.329q-.703 0-1.141.41T10.844 7.5h3.188q-.141-1.523-1.563-1.523zm.125 4.57q.492 0 .953-.25t.594-.68h1.727q-.781 2.398-3.336 2.398-1.672 0-2.66-1.031t-.988-2.711q0-1.625 1.02-2.699T12.533 4.5q1.078 0 1.879.531t1.195 1.398.395 1.937q0 .133-.016.367h-5.141q0 .867.449 1.34t1.301.473zm-10.43-.391h2.313q1.602 0 1.602-1.305 0-1.406-1.555-1.406H2.165v2.711zm0-4.195h2.195q.609 0 .965-.285t.355-.887q0-1.125-1.484-1.125H2.164v2.297zM0 1.984h4.641q.68 0 1.211.109t.988.371.703.754.246 1.203q0 1.414-1.344 2.055.891.25 1.344.898t.453 1.594q0 .586-.191 1.066t-.516.809-.77.555-.945.328-1.047.102H0V1.984z"
		/>
	</svg>
)
